window.addEventListener("load", function () {
    const feedback = document.getElementById('feedback-webpage');

    if (feedback) {
        const form = feedback.querySelector('form'),
            radiobuttons = form.querySelectorAll('input[name="feedback-value"]'),
            close = document.getElementById('feedback-close'),
            labels = form.querySelectorAll('label'),
            inputs = form.querySelectorAll('input');

        radiobuttons.forEach(button => button.addEventListener("click", function (e) {
           
            labels.forEach(label => label.classList.remove('selected'));
            document.querySelector('label[for="' + e.target.id + '"]').classList.add('selected');
            inputs.forEach(input => input.setAttribute('checked', false));
            e.target.setAttribute('checked', true);
            fadeIn(close, 100);

            if (!feedback.classList.contains("active")){
                // Show textarea and submit button
                const feedbackStep2 = document.querySelector('.feedback-step2');
                slideDown(feedbackStep2, 250);
                feedback.classList.add("active");
            }
        }));

        close.addEventListener("click", function (e) {
            feedback.classList.remove("active");

            // Remove 'selected' class from the label
            const selectedLabel = form.querySelector('label.selected');
            if (selectedLabel) {
                selectedLabel.classList.remove('selected');
            }

            // Reset to start state
            const feedbackStep2 = document.querySelector('.feedback-step2'); // Adjust selector as needed
            slideUp(feedbackStep2, 250);

            // Reset radio buttons
            const checkedRadio = form.querySelector('input[name="feedback-value"]:checked');
            if (checkedRadio) {
                checkedRadio.checked = false;
            }

            // Reset textarea
            form.querySelector('textarea').value = '';

            // Fade out close button
            fadeOut(close, 250);
        });

        form.addEventListener("submit", function (e) {

            // Prevent default
            e.preventDefault();

            // Get data
            var data = {};
            data.grade = parseInt(form.querySelector('input[name="feedback-value"][checked="true"]').value);
            data.text = form.querySelector('textarea').value;
            data.pagenodeId = parseInt(feedback.dataset.nodeid);

            // Submit form
            fetch('/umbraco/FeedbackFromWebpage/FeedbackForm/SubmitFeedback', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(() => {
                // Show thank you message
                fadeOut(close, 250);

                const feedbackElements = feedback.querySelectorAll('.feedback-title, .feedback-step1, .feedback-step2');
                feedbackElements.forEach(element => {
                    slideUp(element, 250);
                });

                const submitSuccess = feedback.querySelector('.submit-success');
                slideDown(submitSuccess, 250);
            })
            .catch(err => {
                fadeOut(close, 250);

                const feedbackElements = feedback.querySelectorAll('.feedback-title, .feedback-step1, .feedback-step2');
                feedbackElements.forEach(element => {
                    slideUp(element, 250);
                });

                const submitFail = feedback.querySelector('.submit-fail');
                slideDown(submitFail, 250);
            })

            // Reset input 
            form.querySelector('input[name="feedback-value"]:checked').setAttribute('checked', false);
            form.querySelector('textarea').innerHTML = '';
        });
    }
});

// FadeIn
const fadeIn = (element, duration) => {
    element.style.opacity = 0;
    element.style.display = 'block';
    let opacity = 0;
    const interval = 16; // Approx 60 frames per second
    const increment = interval / duration;

    const animate = () => {
        opacity += increment;
        element.style.opacity = opacity;

        if (opacity < 1) {
            requestAnimationFrame(animate);
        } else {
            element.style.opacity = 1;
        }
    };

    requestAnimationFrame(animate);
};

// FadeOut
const fadeOut = (element, duration) => {
    let opacity = 1;
    const interval = 16; // Approx 60 frames per second
    const decrement = interval / duration;

    const animate = () => {
        opacity -= decrement;
        element.style.opacity = opacity;

        if (opacity > 0) {
            requestAnimationFrame(animate);
        } else {
            element.style.opacity = 0;
            element.style.display = 'none';
        }
    };

    requestAnimationFrame(animate);
};

// slideUp
const slideUp = (element, duration) => {
    const height = element.scrollHeight;
    element.style.overflow = 'hidden';
    element.style.height = `${height}px`;
    element.style.transitionProperty = 'height';
    element.style.transitionDuration = `${duration}ms`;

    requestAnimationFrame(() => {
        element.style.height = 0;
    });

    // Set display to none after transition is complete
    setTimeout(() => {
        element.style.display = 'none';
        element.style.height = '';
        element.style.overflow = '';
        element.style.transitionProperty = '';
        element.style.transitionDuration = '';
    }, duration);
};

// slideDown 
const slideDown = (element, duration) => {
    element.style.display = 'block';
    const height = element.scrollHeight; // Get the full height of the element

    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.transitionProperty = 'height';
    element.style.transitionDuration = `${duration}ms`;

    requestAnimationFrame(() => {
        element.style.height = `${height}px`;
    });

    // Remove the inline styles after the transition is complete
    setTimeout(() => {
        element.style.height = '';
        element.style.overflow = '';
        element.style.transitionProperty = '';
        element.style.transitionDuration = '';
    }, duration);
};
